import { render, staticRenderFns } from "./SmallTextEditDialog.vue?vue&type=template&id=d7c2403a&"
import script from "./SmallTextEditDialog.vue?vue&type=script&lang=js&"
export * from "./SmallTextEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./SmallTextEditDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports